// Save user token and details separately
export const loginUser = ({ token, user }) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
    return null;
  }
};

export const getUsername = () => {
  const user = getCurrentUser();
  return user?.username || user?.email || null;
};

export const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

export const getRole = () => {
  const user = getCurrentUser();
  if (!user || !user.role) return null;
  // Normalize role: lowercase and remove spaces (e.g., "Sub Admin" -> "subadmin", "Admin" -> "admin")
  return user.role.toLowerCase().replace(/\s+/g, "");
};
